import React from "react"
import { ISlider } from "../../../gatsby-graphql"
import Slider from "../../components/slider"
import { Heading } from "../../ui"
import { SectionProps } from "../section-loader"
import {
  ContentWrapper,
  Description,
  SectionWrapper,
} from "./full-width-slider-elements"

interface FullWidthSliderProps extends SectionProps {
  data: {
    heading?: string
    description?: string
    slider?: ISlider
  }
}

const FullWidthSlider = ({ data }: FullWidthSliderProps) => {
  if (!data.slider) {
    return <></>
  }

  return (
    <SectionWrapper>
      <ContentWrapper>
        <Heading.H2>{data.heading}</Heading.H2>
        {data.description && <Description>{data.description}</Description>}
      </ContentWrapper>
      <Slider data={data.slider} dots={false} pageNumbers fade />
    </SectionWrapper>
  )
}

export default FullWidthSlider
